import PropTypes from "prop-types";
import InputBase from "./InputBase";
import ConstrainBase from "../../../model/validate/ConstrainBase";
import { TextField } from "@mui/material";

class InputNumber extends InputBase {
  getValue() {
    return this.inputElementRef.current.value;
  }

  handleKeyDown = (event) => {
    const { type } = this.props;
    if (type === 'number' && event.key.toLowerCase() === 'e') {
      event.preventDefault();
    }

    if (typeof this.props.onKeyDown === 'function') {
      this.props.onKeyDown(event);
    }
  };

  render() {
    const {
      variant = 'outlined',
      type = 'number',
      disabled,
      regex,
      multiline,
      labelElement,
      defaultValue,
      id,
      size,
      helpTextElement,
      sx,
      minRows,
      autoFocus,
      placeholder,
      maxLength,
    } = this.props;

    return (
        <TextField
            variant={variant}
            id={id}
            size={size}
            type={type}
            minRows={minRows}
            sx={sx}
            onKeyDown={(e) => this.handleKeyDown(e)}
            helperText={helpTextElement}
            autoFocus={autoFocus}
            placeholder={placeholder}
            fullWidth
            disabled={disabled}
            multiline={multiline}
            onChange={(e) => this.fireOnChange(e)}
            label={labelElement}
            defaultValue={defaultValue}
            inputRef={this.inputElementRef}
            inputProps={{
              maxLength,
              inputMode: type === 'number' ? 'decimal' : undefined,
              pattern: regex,
            }}
        />
    );
  }
}

InputNumber.propTypes = {
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  constrain: PropTypes.objectOf(ConstrainBase),
  type: PropTypes.oneOf(['text', 'password', 'email', 'phone', 'number']),
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  minRows: PropTypes.number,
  multiline: PropTypes.bool,
  regex: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default InputNumber;